var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("div", { staticClass: "disp-flex" }, [
        _c("div", [
          _c(
            "h1",
            { staticStyle: { display: "inline-block" } },
            [
              _vm.recipient && _vm.recipient.name
                ? [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.recipient.name) +
                        " (" +
                        _vm._s(_vm.recipient.account_id) +
                        ")\n\t\t\t\t"
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.recipient
            ? _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _vm._l(_vm.recipient.tags, function(tag, index) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        staticClass: "recipient-tag",
                        attrs: {
                          size: "mini",
                          type: "info",
                          effect: "dark",
                          closable: tag.can_remove
                        },
                        on: {
                          close: function($event) {
                            return _vm.handleTagRemove(tag.tag, tag.tag_name)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$translate.tag(tag.tag_name)) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.customTags && _vm.customTags.length > 0
                    ? [
                        _vm.showTagSelect
                          ? _c(
                              "el-select",
                              {
                                ref: "selectTag",
                                attrs: { size: "mini" },
                                on: { change: _vm.handleAddTagAdd }
                              },
                              _vm._l(_vm.customTags, function(customTag) {
                                return _c("el-option", {
                                  key: customTag.reference,
                                  attrs: {
                                    label: _vm.$t(customTag.tag),
                                    value: customTag.reference
                                  }
                                })
                              }),
                              1
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: { click: _vm.handleAddTagClick }
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("recipient_detail.add_tag"))
                                )
                              ]
                            )
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-auto" },
          [
            _vm.recipientsDetailRightPanelCollapsed
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toggleRightPanel(false)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("div", { staticStyle: { float: "right" } }, [
                          _c(
                            "svg",
                            {
                              staticClass: "hamburger",
                              staticStyle: { transform: "rotate(180deg)" },
                              attrs: {
                                viewBox: "0 0 1024 1024",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "17",
                                height: "17"
                              }
                            },
                            [
                              _c("path", {
                                staticStyle: {
                                  fill: "white",
                                  "verical-align": "middle !important"
                                },
                                attrs: {
                                  d:
                                    "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              : [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toggleRightPanel(true)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("div", { staticStyle: { float: "right" } }, [
                          _c(
                            "svg",
                            {
                              staticClass: "hamburger",
                              attrs: {
                                viewBox: "0 0 1024 1024",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "17",
                                height: "17"
                              }
                            },
                            [
                              _c("path", {
                                staticStyle: {
                                  fill: "white",
                                  "verical-align": "middle !important"
                                },
                                attrs: {
                                  d:
                                    "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c("el-tab-pane", {
                attrs: {
                  label: _vm.$t("recipientDetail.detail"),
                  name: "DETAIL"
                }
              }),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "MESSAGES",
                    disabled: !_vm.hasMessagesPermission
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      !_vm.hasMessagesPermission
                        ? [_c("i", { staticClass: "el-icon-lock" })]
                        : _vm._e(),
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("recipientDetail.messages")) +
                          "\n\t\t\t\t\t"
                      ),
                      _vm.recipient?.message_recipients?.length > 0
                        ? _c("el-badge", {
                            attrs: {
                              value: _vm.recipient?.message_recipients?.length
                            }
                          })
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "ARCHIVE",
                    disabled: !_vm.hasMessagesPermission
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      !_vm.hasMessagesPermission
                        ? [_c("i", { staticClass: "el-icon-lock" })]
                        : _vm._e(),
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("recipientDetail.archive")) +
                          "\n\t\t\t\t"
                      )
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRecipientReady
        ? _c(
            "el-row",
            { attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                {
                  attrs: { span: _vm.rightPanelLayoutVariables.mainPanelWidth }
                },
                [
                  _vm.recipient &&
                  _vm.recipient.collections &&
                  _vm.recipient.collections.length > 0 &&
                  _vm.recipient.collections[0].custom_fields &&
                  _vm.recipient.collections[0].custom_fields["gdw-dwb"]
                    ? _c(
                        "el-card",
                        { staticClass: "mb-5" },
                        [
                          _c("h4", { staticClass: "mb-15" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("RecipientDetail.collection_status")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "720px" },
                              attrs: {
                                data:
                                  _vm.recipient.collections[0].custom_fields[
                                    "gdw-dwb"
                                  ]
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "stage",
                                  label: _vm.$t(
                                    "RecipientDetail.collection_fase"
                                  ),
                                  width: "180"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "stage_at",
                                  label: _vm.$t(
                                    "RecipientDetail.collection_fase_since"
                                  ),
                                  width: "180"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "status",
                                  label: _vm.$t(
                                    "RecipientDetail.collection_state"
                                  ),
                                  width: "180"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "status_at",
                                  label: _vm.$t(
                                    "RecipientDetail.collection_state_since"
                                  ),
                                  width: "180"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-card", { staticClass: "mb-5 fs-13" }, [
                    _c("div", { staticClass: "row2" }, [
                      _c("div", { staticClass: "disp-flex" }, [
                        _c("div", { staticClass: "p-15 pr-25 b-r-blue" }, [
                          _c("div", { staticClass: "mb-20" }, [
                            _c("div", { staticClass: "mb-5" }, [
                              _vm._v(_vm._s(_vm.$t("openBalanceAmount")))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "fs-18" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$formatter.toCurrency(
                                      _vm.recipient.balance_amount,
                                      _vm.recipient.currency
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-20" }, [
                            _c("div", { staticClass: "mb-5" }, [
                              _vm._v(_vm._s(_vm.$t("openBalanceCosts")))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "fs-18" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$formatter.toCurrency(
                                      _vm.recipient.last_dunning_costs,
                                      _vm.recipient.currency
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "mb-5" }, [
                              _vm._v(_vm._s(_vm.$t("openBalanceTotal")))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "fs-18" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$formatter.toCurrency(
                                      _vm.recipient.balance_amount,
                                      _vm.recipient.currency
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "p-15 pr-25 pr-25 b-r-blue" },
                          [
                            _c("div", { staticClass: "mb-20" }, [
                              _c("div", { staticClass: "mb-5" }, [
                                _vm._v(_vm._s(_vm.$t("dueBalanceAmount")))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$formatter.toCurrency(
                                        _vm.recipient.due_balance_amount,
                                        _vm.recipient.currency
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-20" }, [
                              _c("div", { staticClass: "mb-5" }, [
                                _vm._v(_vm._s(_vm.$t("dueBalanceCosts")))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$formatter.toCurrency(
                                        _vm.recipient.last_dunning_costs,
                                        _vm.recipient.currency
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "mb-5" }, [
                                _vm._v(_vm._s(_vm.$t("dueBalanceTotal")))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-18" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$formatter.toCurrency(
                                        _vm.recipient.due_balance_amount +
                                          _vm.recipient.last_dunning_costs,
                                        _vm.recipient.currency
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        false && _vm.beta && _vm.latestActionBeforePayment
                          ? _c(
                              "div",
                              { staticClass: "p-15 pl-25 pr-25 b-r-blue" },
                              [
                                _c("div", [
                                  _c("div", { staticClass: "mb-10" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("latestActionBeforePayment")
                                      ) + " "
                                    ),
                                    _c("sup", [_vm._v("beta")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _vm.latestActionBeforePayment.channel ==
                                      "PHONE"
                                        ? [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                color: "rgb(32, 160, 255)",
                                                "font-size": "20px"
                                              },
                                              attrs: {
                                                "icon-class": "phone-solid"
                                              }
                                            })
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.latestActionBeforePayment.channel ==
                                      "EMAIL"
                                        ? [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                color: "rgb(32, 160, 255)",
                                                "font-size": "20px"
                                              },
                                              attrs: {
                                                "icon-class": "at-solid"
                                              }
                                            })
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.latestActionBeforePayment.channel ==
                                      "SMS"
                                        ? [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                color: "rgb(32, 160, 255)",
                                                "font-size": "20px"
                                              },
                                              attrs: {
                                                "icon-class": "sms-solid"
                                              }
                                            })
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.latestActionBeforePayment.channel ==
                                      "MAIL"
                                        ? [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                color: "rgb(32, 160, 255)",
                                                "font-size": "20px"
                                              },
                                              attrs: {
                                                "icon-class": "envelope-solid"
                                              }
                                            })
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "mb-5" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$translate.channel(
                                                _vm.latestActionBeforePayment
                                                  .channel
                                              )
                                            ) +
                                            " (" +
                                            _vm._s(
                                              _vm.$translate.action_message_code(
                                                _vm.latestActionBeforePayment
                                                  .message_code
                                              )
                                            ) +
                                            ")\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("@")]),
                                      _vm._v(" "),
                                      _vm.latestActionBeforePayment
                                        .executed_at !== null
                                        ? [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("parseTime")(
                                                    _vm
                                                      .latestActionBeforePayment
                                                      .executed_at,
                                                    "{d}-{m}-{y} - {h}:{i}"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mt-5" },
                                        [
                                          _vm._l(
                                            _vm.latestActionBeforePayment
                                              .action_invoices,
                                            function(inv) {
                                              return [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    key: inv.invoice,
                                                    attrs: { size: "mini" }
                                                  },
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "hover-underline",
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "invoice-detail",
                                                            params: {
                                                              participant:
                                                                _vm.selectedParticipantStore,
                                                              reference:
                                                                inv.invoice
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              inv
                                                                .invoice_by_reference
                                                                .invoice_number
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.nextDraftActions && _vm.nextDraftActions.length > 0
                          ? _c(
                              "div",
                              { staticClass: "p-15 pl-25 pr-25 b-r-blue" },
                              [
                                _c("div", { staticClass: "mb-10" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("firstNextActions")) + ":"
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.nextDraftActions, function(
                                  nextDraftAction
                                ) {
                                  return _c(
                                    "div",
                                    { key: nextDraftAction.reference },
                                    [
                                      _c(
                                        "div",
                                        [
                                          nextDraftAction.channel == "PHONE"
                                            ? [
                                                _c("svg-icon", {
                                                  staticStyle: {
                                                    color: "rgb(32, 160, 255)",
                                                    "font-size": "15px"
                                                  },
                                                  attrs: {
                                                    "icon-class": "phone-solid"
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          nextDraftAction.channel == "EMAIL"
                                            ? [
                                                _c("svg-icon", {
                                                  staticStyle: {
                                                    color: "rgb(32, 160, 255)",
                                                    "font-size": "15px"
                                                  },
                                                  attrs: {
                                                    "icon-class": "at-solid"
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          nextDraftAction.channel == "SMS"
                                            ? [
                                                _c("svg-icon", {
                                                  staticStyle: {
                                                    color: "rgb(32, 160, 255)",
                                                    "font-size": "15px"
                                                  },
                                                  attrs: {
                                                    "icon-class": "sms-solid"
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          nextDraftAction.channel == "MAIL"
                                            ? [
                                                _c("svg-icon", {
                                                  staticStyle: {
                                                    color: "rgb(32, 160, 255)",
                                                    "font-size": "15px"
                                                  },
                                                  attrs: {
                                                    "icon-class":
                                                      "envelope-solid"
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$translate.action_message_code(
                                                  nextDraftAction.message_code
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                nextDraftAction.is_retry
                                                  ? " ↺"
                                                  : ""
                                              ) +
                                              " @ " +
                                              _vm._s(
                                                _vm._f("parseTime")(
                                                  nextDraftAction.start_time,
                                                  "{d}-{m}-{y}"
                                                )
                                              ) +
                                              " " +
                                              _vm._s(_vm.$t("for")) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                          nextDraftAction.primary_invoice_by_reference &&
                                          nextDraftAction
                                            .primary_invoice_by_reference
                                            .invoice_number
                                            ? [
                                                _c(
                                                  "strong",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(32, 160, 255)"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          nextDraftAction
                                                            .primary_invoice_by_reference
                                                            .invoice_number
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      nextDraftAction.metadata.channels[0] &&
                                      nextDraftAction.metadata.channels[0].to &&
                                      (nextDraftAction.channel === "PHONE" ||
                                        nextDraftAction.channel === "EMAIL")
                                        ? _c("div", { staticClass: "mb-10" }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t(" +
                                                _vm._s(
                                                  nextDraftAction.metadata
                                                    .channels[0].to
                                                ) +
                                                ")\n\t\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "mt-10",
                                    attrs: { size: "mini" },
                                    on: { click: _vm.onShowAllNextActions }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("showAll")) +
                                        " (" +
                                        _vm._s(_vm.totalNextDraftActions) +
                                        ") "
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          : _c(
                              "div",
                              { staticClass: "p-15 pl-25 pr-25 b-r-blue" },
                              [
                                _c("div", { staticClass: "mb-10" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("firstNextActions")) + ":"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "mt-10",
                                    attrs: { size: "mini" },
                                    on: { click: _vm.onShowAllNextActions }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("showAll")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "p-15 pl-25" },
                          [
                            _vm.recipient && _vm.recipient.last_dunning_run_at
                              ? [
                                  _c("div", { staticClass: "mb-10" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("lastDunningRunAt")) + ":"
                                    )
                                  ]),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("parseTime")(
                                          _vm.recipient.last_dunning_run_at,
                                          "{d}-{m}-{y} @ {h}:{i}"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showTriggerDunning
                              ? [
                                  _c("el-button", {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      icon: "el-icon-refresh"
                                    },
                                    on: { click: _vm.onTriggerDunning }
                                  })
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mt-10 mb-10" },
                              [
                                _vm.recipient.type === "B2C"
                                  ? [
                                      _vm._v(
                                        "👤   " + _vm._s(_vm.recipient.type)
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.recipient.type === "B2B"
                                  ? [
                                      _vm._v(
                                        "🏢   " +
                                          _vm._s(_vm.recipient.type) +
                                          " " +
                                          _vm._s(_vm.recipient.legal_id)
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-10 mb-10" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("legalEntity")) +
                                  ": " +
                                  _vm._s(
                                    _vm.recipient.legal_entity_by_reference
                                      .registration_name
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          2
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.userInterfaceDetails.use_accounting_documents_table
                    ? _c(
                        "el-card",
                        { staticClass: "mb-5" },
                        [
                          _c("div", { staticClass: "mb-15" }, [
                            _c("h4", [
                              _vm._v(_vm._s(_vm.$tc("documents", 777)))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("document-table", {
                            attrs: {
                              recipient: _vm.recipientRef,
                              "full-recipient": _vm.recipient,
                              "disable-payment-plan":
                                _vm.hasPaymentPlan ||
                                (_vm.recipient.in_collection &&
                                  !_vm.recipient.legal_entity_by_reference
                                    .payment_plan.payment_plan_in_collection),
                              "disable-payment-plan-reason":
                                _vm.recipient.in_collection &&
                                !_vm.recipient.legal_entity_by_reference
                                  .payment_plan.payment_plan_in_collection
                                  ? _vm.$t("InvoiceTable.disable_payment_plan")
                                  : null
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isRecipientReady &&
                  !_vm.userInterfaceDetails.use_accounting_documents_table
                    ? _c(
                        "el-card",
                        { staticClass: "mb-5" },
                        [
                          _c("div", { staticClass: "mb-15" }, [
                            _c("h4", [_vm._v(_vm._s(_vm.$tc("invoice", 777)))])
                          ]),
                          _vm._v(" "),
                          _vm.isRecipientReady &&
                          !_vm.userInterfaceDetails
                            .use_accounting_documents_table
                            ? _c("invoice-table", {
                                attrs: {
                                  recipient: _vm.recipientRef,
                                  "disable-payment-plan":
                                    _vm.hasPaymentPlan ||
                                    (_vm.recipient.in_collection &&
                                      !_vm.recipient.legal_entity_by_reference
                                        .payment_plan
                                        .payment_plan_in_collection),
                                  "disable-payment-plan-reason":
                                    _vm.recipient.in_collection &&
                                    !_vm.recipient.legal_entity_by_reference
                                      .payment_plan.payment_plan_in_collection
                                      ? _vm.$t(
                                          "InvoiceTable.disable_payment_plan"
                                        )
                                      : null,
                                  "props-document-type": ["INVOICE"],
                                  "props-statuses": [
                                    "OPEN",
                                    "OVERDUE",
                                    "CLOSED"
                                  ],
                                  "props-page": _vm.invoicesPage,
                                  "props-limit": _vm.invoicesLimit,
                                  "props-sort": _vm.invoicesSort,
                                  "full-recipient": _vm.recipient,
                                  "highlight-current-row-prop": false,
                                  "show-actions": true,
                                  "props-columns": {
                                    manualActionPossible: true,
                                    selection: true,
                                    deliveryDetails: true,
                                    invoiceNumber: true,
                                    legalEntity: false,
                                    lastDunningStatus: true,
                                    recipient: false,
                                    paymentReference: true,
                                    status: true,
                                    paidAtDate: true,
                                    issueDate: true,
                                    dueDate: true,
                                    totalAmount: true,
                                    openAmount: true,
                                    showGoTo: true,
                                    pdf: true,
                                    processingDueDate: true
                                  }
                                },
                                on: {
                                  "update:propsPage": function($event) {
                                    _vm.invoicesPage = $event
                                  },
                                  "update:props-page": function($event) {
                                    _vm.invoicesPage = $event
                                  },
                                  "update:propsLimit": function($event) {
                                    _vm.invoicesLimit = $event
                                  },
                                  "update:props-limit": function($event) {
                                    _vm.invoicesLimit = $event
                                  },
                                  "update:propsSort": function($event) {
                                    _vm.invoicesSort = $event
                                  },
                                  "update:props-sort": function($event) {
                                    _vm.invoicesSort = $event
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isRecipientReady &&
                  !_vm.userInterfaceDetails.use_accounting_documents_table &&
                  _vm.creditnotes &&
                  _vm.creditNotestotal > 0
                    ? _c("el-card", { staticClass: "mb-5" }, [
                        _c("div", { staticClass: "mb-15" }, [
                          _c("h4", [_vm._v(_vm._s(_vm.$tc("creditnote", 777)))])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "smallForm mb-10",
                                attrs: { inline: "" },
                                nativeOn: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.selectedCreditNotes == undefined
                                              ? true
                                              : _vm.selectedCreditNotes
                                                  .length != 1,
                                          type: "primary",
                                          size: "mini",
                                          loading:
                                            _vm.sendCreditNoteCopyEmailloading
                                        },
                                        on: {
                                          click:
                                            _vm.handleSendCreditNoteCopyEmail
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t("actions.send_copy_email")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.selectedCreditNotes == undefined
                                              ? true
                                              : _vm.selectedCreditNotes
                                                  .length != 1,
                                          type: "primary",
                                          size: "mini",
                                          loading:
                                            _vm.sendCreditNoteCopyMailloading
                                        },
                                        on: {
                                          click:
                                            _vm.handleSendCreditNoteCopyMail
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t("actions.send_copy_mail")
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.creditsLoading,
                                    expression: "creditsLoading"
                                  }
                                ],
                                ref: "creditNotesTable",
                                attrs: { data: _vm.creditnotes },
                                on: {
                                  "selection-change":
                                    _vm.handleCreditNotesSelectionChange
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "selection", width: "48" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "credit_note_number",
                                    label: _vm.$t("creditNoteNumber"),
                                    "show-overflow-tooltip": ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "hover-underline blueColor",
                                                attrs: {
                                                  to: {
                                                    name: "credit-note-detail",
                                                    params: {
                                                      participant:
                                                        _vm.selectedParticipantStore,
                                                      reference:
                                                        scope.row.reference
                                                    }
                                                  }
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return $event.stopImmediatePropagation()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      scope.row
                                                        .credit_note_number
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3051334793
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "status", label: "Status" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: _vm._f(
                                                    "risoltoStatusFilter"
                                                  )(scope.row.status)
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$translate.invoice_status(
                                                        scope.row.status
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3958312314
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "issue_date",
                                    label: _vm.$t("issueDate")
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row.issue_date
                                              ? [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm._f("parseTime")(
                                                          scope.row.issue_date,
                                                          "{d}-{m}-{y}"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2801120495
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "total_amount",
                                    label: _vm.$t("totalAmount"),
                                    align: "right",
                                    width: "128"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.total_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1762172067
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "open_amount",
                                    label: _vm.$t("open"),
                                    align: "right",
                                    width: "128"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.open_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3596754517
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "amount_currency",
                                    label: _vm.$t("currency")
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    "show-overflow-tooltip": "",
                                    align: "left"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return _vm._l(
                                            scope.row.file_references,
                                            function(file, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "disp-inline"
                                                },
                                                [
                                                  _vm.isPdf(file)
                                                    ? _c("svg-icon", {
                                                        staticClass: "fc-blue",
                                                        staticStyle: {
                                                          "font-size":
                                                            "14px !important",
                                                          "vertical-align":
                                                            "middle"
                                                        },
                                                        attrs: {
                                                          "icon-class":
                                                            "file-invoice-solid"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onClickDocIcon(
                                                              file
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.isXml(file)
                                                    ? _c("svg-icon", {
                                                        staticClass: "fc-blue",
                                                        staticStyle: {
                                                          "font-size":
                                                            "14px !important",
                                                          "vertical-align":
                                                            "middle"
                                                        },
                                                        attrs: {
                                                          "icon-class":
                                                            "file-code-solid"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onClickDocIcon(
                                                              file
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            }
                                          )
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    4126600806
                                  )
                                }),
                                _vm._v(" "),
                                _vm.userInterfaceDetails &&
                                _vm.userInterfaceDetails
                                  .credit_note_custom_field_definitions &&
                                _vm.userInterfaceDetails
                                  .credit_note_custom_field_definitions.length >
                                  0
                                  ? _vm._l(
                                      _vm.userInterfaceDetails.credit_note_custom_field_definitions.slice(
                                        0,
                                        3
                                      ),
                                      function(custom_field_definition) {
                                        return _c(
                                          "el-table-column",
                                          {
                                            key: custom_field_definition.path,
                                            attrs: { width: "148" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _c("custom-field-value", {
                                                        attrs: {
                                                          "custom-field-definition": custom_field_definition,
                                                          "custom-fields":
                                                            scope.row
                                                              .custom_fields
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "header" },
                                              [
                                                _c("custom-field-label", {
                                                  attrs: {
                                                    "custom-field-definition": custom_field_definition
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      }
                                    )
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("pagination", {
                                  staticClass: "p-5",
                                  attrs: {
                                    total: _vm.creditNotestotal,
                                    page: _vm.creditNotePage,
                                    "page-sizes": [5, 10],
                                    limit: _vm.creditnoteLimit,
                                    "auto-scroll": false
                                  },
                                  on: {
                                    "update:page": function($event) {
                                      _vm.creditNotePage = $event
                                    },
                                    "update:limit": function($event) {
                                      _vm.creditnoteLimit = $event
                                    },
                                    pagination: data =>
                                      _vm.getCreditNotes(data.page, data.limit)
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isRecipientReady &&
                  !_vm.userInterfaceDetails.use_accounting_documents_table &&
                  _vm.debitnotes &&
                  _vm.debitnotesTotal > 0
                    ? _c("el-card", { staticClass: "mb-5" }, [
                        _c("div", { staticClass: "mb-15" }, [
                          _c("h4", [_vm._v(_vm._s(_vm.$tc("debitnote", 777)))])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.debitnotesLoading,
                                    expression: "debitnotesLoading"
                                  }
                                ],
                                ref: "debitNotesTable",
                                attrs: { data: _vm.debitnotes }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "debit_note_number",
                                    label: _vm.$t("debitNoteNumber"),
                                    "show-overflow-tooltip": ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "hover-underline blueColor",
                                                attrs: {
                                                  to: {
                                                    name: "debit-note-detail",
                                                    params: {
                                                      participant:
                                                        _vm.selectedParticipantStore,
                                                      reference:
                                                        scope.row.reference
                                                    }
                                                  }
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return $event.stopImmediatePropagation()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      scope.row
                                                        .debit_note_number
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    860133449
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "issue_date",
                                    label: _vm.$t("issueDate")
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row.issue_date
                                              ? [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm._f("parseTime")(
                                                          scope.row.issue_date,
                                                          "{d}-{m}-{y}"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2801120495
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "processing_status",
                                    label: _vm.$t("processingStatus")
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "total_amount",
                                    label: _vm.$t("totalAmount"),
                                    align: "right",
                                    width: "128"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.total_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3022851491
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "open_amount",
                                    label: _vm.$t("open"),
                                    align: "right",
                                    width: "128"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.open_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3596754517
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "amount_currency",
                                    label: _vm.$t("currency")
                                  }
                                }),
                                _vm._v(" "),
                                _vm.userInterfaceDetails &&
                                _vm.userInterfaceDetails
                                  .debit_note_custom_field_definitions &&
                                _vm.userInterfaceDetails
                                  .debit_note_custom_field_definitions.length >
                                  0
                                  ? _vm._l(
                                      _vm.userInterfaceDetails.debit_note_custom_field_definitions.slice(
                                        0,
                                        3
                                      ),
                                      function(custom_field_definition) {
                                        return _c(
                                          "el-table-column",
                                          {
                                            key: custom_field_definition.path,
                                            attrs: { width: "148" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _c("custom-field-value", {
                                                        attrs: {
                                                          "custom-field-definition": custom_field_definition,
                                                          "custom-fields":
                                                            scope.row
                                                              .custom_fields
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "header" },
                                              [
                                                _vm._v("å\n\t\t\t\t\t\t\t\t\t"),
                                                _c("custom-field-label", {
                                                  attrs: {
                                                    "custom-field-definition": custom_field_definition
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      }
                                    )
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("pagination", {
                                  staticClass: "p-5",
                                  attrs: {
                                    total: _vm.debitnotesTotal,
                                    page: _vm.debitNotePage,
                                    "page-sizes": [5, 10],
                                    limit: _vm.debitnoteLimit,
                                    "auto-scroll": false
                                  },
                                  on: {
                                    "update:page": function($event) {
                                      _vm.debitNotePage = $event
                                    },
                                    "update:limit": function($event) {
                                      _vm.debitnoteLimit = $event
                                    },
                                    pagination: data =>
                                      _vm.getDebitNotes(data.page, data.limit)
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isRecipientReady &&
                  !_vm.userInterfaceDetails.use_accounting_documents_table &&
                  _vm.paymentDocuments &&
                  _vm.paymentDocumentsTotal > 0
                    ? _c("el-card", { staticClass: "mb-5" }, [
                        _c("div", { staticClass: "mb-15" }, [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$tc("paymentDocuments", 777)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.paymentDocumentsLoading,
                                    expression: "paymentDocumentsLoading"
                                  }
                                ],
                                ref: "paymentDocumentsTable",
                                attrs: { data: _vm.paymentDocuments }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "payment_number",
                                    label: _vm.$t("paymentDocumentNumber"),
                                    "show-overflow-tooltip": ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "hover-underline blueColor",
                                                attrs: {
                                                  to: {
                                                    name:
                                                      "payment-document-detail",
                                                    params: {
                                                      participant:
                                                        _vm.selectedParticipantStore,
                                                      reference:
                                                        scope.row.reference
                                                    }
                                                  }
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return $event.stopImmediatePropagation()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      scope.row.payment_number
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    947017849
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "issue_date",
                                    label: _vm.$t("issueDate")
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row.issue_date
                                              ? [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm._f("parseTime")(
                                                          scope.row.issue_date,
                                                          "{d}-{m}-{y}"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2801120495
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "processing_status",
                                    label: _vm.$t("processingStatus")
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "total_amount",
                                    label: _vm.$t("totalAmount"),
                                    align: "right",
                                    width: "128"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.total_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1762172067
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "open_amount",
                                    label: _vm.$t("open"),
                                    align: "right",
                                    width: "128"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.open_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    641494869
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "amount_currency",
                                    label: _vm.$t("currency")
                                  }
                                }),
                                _vm._v(" "),
                                _vm.userInterfaceDetails &&
                                _vm.userInterfaceDetails
                                  .payment_document_custom_field_definitions &&
                                _vm.userInterfaceDetails
                                  .payment_document_custom_field_definitions
                                  .length > 0
                                  ? _vm._l(
                                      _vm.userInterfaceDetails.payment_document_custom_field_definitions.slice(
                                        0,
                                        3
                                      ),
                                      function(custom_field_definition) {
                                        return _c(
                                          "el-table-column",
                                          {
                                            key: custom_field_definition.path,
                                            attrs: { width: "148" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _c("custom-field-value", {
                                                        attrs: {
                                                          "custom-field-definition": custom_field_definition,
                                                          "custom-fields":
                                                            scope.row
                                                              .custom_fields
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "header" },
                                              [
                                                _c("custom-field-label", {
                                                  attrs: {
                                                    "custom-field-definition": custom_field_definition
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      }
                                    )
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("pagination", {
                                  staticClass: "p-5",
                                  attrs: {
                                    total: _vm.paymentDocumentsTotal,
                                    page: _vm.paymentDocumentsPage,
                                    "page-sizes": [5, 10],
                                    limit: _vm.paymentDocumentsPageCountLimit,
                                    "auto-scroll": false
                                  },
                                  on: {
                                    "update:page": function($event) {
                                      _vm.paymentDocumentsPage = $event
                                    },
                                    "update:limit": function($event) {
                                      _vm.paymentDocumentsPageCountLimit = $event
                                    },
                                    pagination: data =>
                                      _vm.getPaymentDocuments(
                                        data.page,
                                        data.limit
                                      )
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paymentPlans && _vm.paymentPlans.length > 0
                    ? _c("el-card", { staticClass: "mb-5" }, [
                        _c("div", { staticClass: "mb-15" }, [
                          _c("h4", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("recipient_detail.payment_plans.title")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-table",
                              { attrs: { data: _vm.paymentPlans } },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "expand" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pt-20 pr-20 pl-20 pb-50"
                                              },
                                              [
                                                _c("h4", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "recipient_detail.payment_promises.title"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "el-table",
                                                  {
                                                    attrs: {
                                                      data:
                                                        props.row
                                                          .payment_promises
                                                    }
                                                  },
                                                  [
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop:
                                                          "payment_reference",
                                                        label: _vm.$t(
                                                          "recipient_detail.payment_promises.payment_reference"
                                                        ),
                                                        width: "192"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "due_date",
                                                        label: _vm.$t(
                                                          "recipient_detail.payment_promises.due_date"
                                                        )
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(
                                                              scope
                                                            ) {
                                                              return [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "parseTime"
                                                                    )(
                                                                      scope.row
                                                                        .due_date,
                                                                      "{d}-{m}-{y}"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "total_amount",
                                                        label: _vm.$t(
                                                          "recipient_detail.payment_promises.total_amount"
                                                        ),
                                                        align: "right",
                                                        width: "128"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(
                                                              scope
                                                            ) {
                                                              return [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$formatter.toCurrency(
                                                                      scope.row
                                                                        .total_amount,
                                                                      scope.row
                                                                        .amount_currency
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "open_amount",
                                                        label: _vm.$t(
                                                          "recipient_detail.payment_promises.open_amount"
                                                        ),
                                                        align: "right",
                                                        width: "128"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(
                                                              scope
                                                            ) {
                                                              return [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$formatter.toCurrency(
                                                                      scope.row
                                                                        .open_amount,
                                                                      scope.row
                                                                        .amount_currency
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "status",
                                                        label: _vm.$t(
                                                          "recipient_detail.payment_promises.status"
                                                        )
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(
                                                              scope
                                                            ) {
                                                              return [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        scope
                                                                          .row
                                                                          .status
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3143366739
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "status",
                                    label: _vm.$t(
                                      "recipient_detail.payment_plans.status"
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "name",
                                    label: _vm.$t(
                                      "recipient_detail.payment_plans.name"
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "total_amount",
                                    label: _vm.$t(
                                      "recipient_detail.payment_plans.total_amount"
                                    ),
                                    align: "right",
                                    width: "128"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.total_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1762172067
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "open_amount",
                                    label: _vm.$t(
                                      "recipient_detail.payment_plans.open_amount"
                                    ),
                                    align: "right",
                                    width: "128"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.open_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    641494869
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "recipient_detail.payment_promises.actions"
                                    ),
                                    width: "160"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { size: "mini" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleShowPaymentPlanDetail(
                                                      scope.row.reference
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "recipient_detail.payment_promises.show_detail"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3001117731
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "mb-5" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            {
                              attrs: {
                                recipient: _vm.recipient.reference,
                                span: 12
                              }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("MainContacts", {
                                    attrs: {
                                      recipient: _vm.recipient.reference,
                                      "legal-entity":
                                        _vm.recipient.legal_entity,
                                      "allow-edit":
                                        _vm.userInterfaceDetails &&
                                        _vm.userInterfaceDetails
                                          .recipient_allow_edit
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.recipient && _vm.recipient.custom_fields
                                ? _c(
                                    "div",
                                    [
                                      _c("h4", { staticClass: "mt-20 mb-10" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("shared.custom_fields"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.userInterfaceDetails &&
                                      _vm.userInterfaceDetails
                                        .custom_field_definitions
                                        ? _c("custom-fields-list", {
                                            attrs: {
                                              "custom-field-definitions":
                                                _vm.userInterfaceDetails
                                                  .custom_field_definitions,
                                              "custom-fields":
                                                _vm.recipient.custom_fields
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "mb-10",
                                          attrs: { size: "mini" },
                                          on: {
                                            click: function($event) {
                                              _vm.showCustomFields = !_vm.showCustomFields
                                            }
                                          }
                                        },
                                        [
                                          _vm.showCustomFields
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "shared.hide_custom_fields"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "shared.show_custom_fields"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showCustomFields
                                        ? _c("json-editor", {
                                            attrs: {
                                              value: _vm.recipient.custom_fields
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("h4", { staticClass: "mb-10" }, [
                              _vm._v(
                                _vm._s(_vm.$t("invoice-disputes.attachments"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "attachments" },
                              [
                                _vm._l(_vm.recipientAttachments, function(
                                  attachment,
                                  index
                                ) {
                                  return _c(
                                    "el-button",
                                    {
                                      key: index,
                                      attrs: { type: "text" },
                                      on: { click: _vm.handleAttachments }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(attachment.name) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "mt-5",
                                    attrs: { type: "text" },
                                    on: { click: _vm.handleAttachments }
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-plus" }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "invoice-disputes.no_attachments"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-20 mb-10" }, [
                              _c("h4", [
                                _vm._v(_vm._s(_vm.$tc("contact", 777)))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "contacts" },
                              [
                                _vm.recipient && _vm.recipient.reference
                                  ? [
                                      _c("contacts", {
                                        attrs: {
                                          recipient: _vm.recipient.reference,
                                          "legal-entity":
                                            _vm.recipient.legal_entity,
                                          "allow-edit":
                                            _vm.userInterfaceDetails &&
                                            _vm.userInterfaceDetails
                                              .contact_allow_edit,
                                          selectable: false
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "disp-flex" })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "mb-5" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              { staticClass: "transparentDashboardCard" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mb-20 fs-17 fw-b text-color--dark-gray text-center"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("avgPaymentDuration")) +
                                        " (N/A)"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [_c("avg-payment")],
                                  1
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              { staticClass: "transparentDashboardCard" },
                              [
                                _c("risk-score", {
                                  attrs: {
                                    score: _vm.recipient.prediction_stars
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "mb-5" },
                    [
                      _vm.recipient && _vm.recipient.reference
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mb-20 fs-17 fw-b text-color--dark-gray text-center"
                              },
                              [_vm._v("Aging Balance")]
                            ),
                            _vm._v(" "),
                            _c("AgingBalance", {
                              attrs: { recipient: _vm.recipient.reference }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  attrs: { span: _vm.rightPanelLayoutVariables.rightPanelWidth }
                },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        staticClass: "pb-20",
                        staticStyle: {
                          "overflow-y": "scroll",
                          "max-height": "85vh"
                        }
                      },
                      [
                        _c("actions-notes", {
                          attrs: {
                            recipient: _vm.recipient.reference,
                            "legal-entity": _vm.recipient.legal_entity
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.recipient
        ? _c("attachments-dialog", {
            attrs: {
              visible: _vm.attachmentsDialogVisible,
              participant: _vm.$store.state.risolto.selectedParticipantStore,
              "legal-entity": _vm.recipient.legal_entity,
              "file-list": _vm.recipientAttachments,
              "on-upload": _vm.handleAttachmentUpload,
              "on-remove": _vm.handleAttachmentRemove
            },
            on: {
              "dialog-close": function($event) {
                _vm.attachmentsDialogVisible = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showActionTable, width: "98%" },
          on: {
            "update:visible": function($event) {
              _vm.showActionTable = $event
            }
          }
        },
        [
          _vm.showActionTable && _vm.recipient
            ? _c("recipient-action-table", {
                attrs: { recipient: _vm.recipient.reference },
                on: {
                  close: function($event) {
                    _vm.showActionTable = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }